<button htm-button routerLink="{{ '/töölaud/gdpr' | translatePath }}" theme="outline" role="link"
  data-test-id="sidebar-gdpr-button"
  >{{'gdpr_button.checkdata' | translate}}</button>
